export default function setupAxios(axios: any, store: any) {
  var numberOfPendigRequest: string[] = [];
  axios.interceptors.request.use(
    (config: any) => {
      // var data = btoa(`${config.url}${JSON.stringify(config.data)}`);
      // if (numberOfPendigRequest.indexOf(data) == -1) {
      //   numberOfPendigRequest = [...numberOfPendigRequest, data]
      // } else {
      //   return {
      //     headers: {},
      //     method: config.method,
      //     url: "#"
      //   };
      // }
      const {
        auth: { accessToken, humanVerificationToken },
      } = store.getState()

      if (accessToken) {
        config.headers.Authorization = `Bearer ${accessToken.access_token}`
      }
      if (humanVerificationToken) {
        config.headers.HumanVerification = `${humanVerificationToken}`
      }
      return config;
    },
    (err: any) => {
      Promise.reject(err);
    }
  )

  // axios.interceptors.response.use(
  //   (originalResponse: any) => {
  //     if (originalResponse.config) {
  //       var data = btoa(`${originalResponse.config.url}${originalResponse.config.data}`);
  //       numberOfPendigRequest = numberOfPendigRequest.filter(x => x != data);
  //     }
  //     return originalResponse;
  //   },
  //   (err: any) => {
  //     if (err.config) {
  //       var data = btoa(`${err.config.url}${err.config.data}`);
  //       numberOfPendigRequest = numberOfPendigRequest.filter(x => x != data);
  //     }
  //     Promise.reject(err)
  //   }
  // );
  // axios.interceptors.response.use(
  //   (originalResponse: any) => {
  //     handleDates(originalResponse.data);
  //     return originalResponse;
  //   },
  //   (err: any) => Promise.reject(err)
  // );
}

const isoDateFormat = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\.\d\w*)?$/;

function isIsoDateString(value: any): boolean {
  return value && typeof value === "string" && isoDateFormat.test(value);
}

export function handleDates(body: any) {
  if (body === null || body === undefined || typeof body !== "object")
    return body;

  for (const key of Object.keys(body)) {
    const value = body[key];
    if (isIsoDateString(value)) body[key] = new Date(value);
    else if (typeof value === "object") handleDates(value);
  }
}